// extracted by mini-css-extract-plugin
export default {"wrap":"CoursesPage_wrap__fPwTr","heading":"CoursesPage_heading__SqPy8","courseGrid":"CoursesPage_courseGrid__f-FQo","courseAdd":"CoursesPage_courseAdd__Q0h8A"};